import styled, { css } from "styled-components";
import { RouteComponentProps, withRouter } from 'react-router-dom';

export const FooterWrapper = styled.footer`
  position: fixed;
  display: block;
  justify-content: space-between;
  width: 100%;
  padding: 0px 0px;
  bottom: 10px;
  right: 10px;
  text-align: right;
  @media (max-width: 991px){
    position: relative;
    left: inherit;
    bottom: inherit;
    margin-top: 0px;
    text-align: center;
    display: inline-block;
    justify-content: inherit;
    width: 100%;
  }
`;

const _ListFooterLink = styled.ul<RouteComponentProps>`
  margin: 0px;
  padding: 0px 30px;
  @media (max-width: 991px){
    width: 80%;
    margin: 0 auto;
    text-align: center;
    padding: 0px;
    padding-bottom: 30px;
  }
  &.right{
    text-align: right;
    float: right;
    @media (max-width: 991px){
        float: inherit;
        text-align: center;
      }
    li{
      text-align: left;
      float: left;
      &:first-child{
        margin-bottom: 5px;
      }
      @media (max-width: 991px){
        float: inherit;
        text-align: center;
        display: inline-block;
      }
    }
  }
  span{
    color: #000;
    text-transform: uppercase;
    font-weight: 900;
  }
  li {
    list-style: none;
    float: right;
    padding: 0px 4px;
    font-size: 12px;
    color: #4a4a4a;
    @media (max-width: 991px){
        float: inherit;
        padding: 0px 10px;
        text-align: center;
        color: #4a4a4a;
        display: inline-block;
      }
    &:last-child{
      border-right: 0px;
    }
    a{
      color: #4a4a4a;
      text-decoration: inherit;
      margin: 0px;
      font-weight: normal;
      @media (max-width: 991px){
        color: #4a4a4a;
      }
      &:hover{
        color: #4a4a4a;
      }
    }
  }
  ${props => (
    props.match.path.startsWith('/message')
  ) && css`
    @media (max-width: 991px){
      li{
        a{
          @media (max-width: 991px){
            color: #000;
          }
        }
      }
    }
    
  `
  }
`;

export const ListFooterLink = withRouter(_ListFooterLink);